import React, { FC, useContext, useState } from "react";
import { connect } from 'react-redux'
import { Button, Header, Icon, Image, List, Modal } from "semantic-ui-react";
import { toast } from "react-toastify";

import { bookingAddedSupplements } from "../../../store/supplement";
import { RootDispatch, RootState } from "../../../../src/store";
import Utility from "../../../../src/Utility";
import GlobalContext from "../../../contexts/GlobalContext";

import AmountProvider from "../../../components/Provider/AmountProvider";

const mapProps = (state: RootState) => ({
  options: state.supplement.options,
  extras: state.supplement.extras,
  bookingAddedSupplements: bookingAddedSupplements(state),
  bookingFolder: state.booking.bookingFolder
});

const mapDispatch = (dispatch: RootDispatch) => ({
  handleRedirectTypeAsync: dispatch.authentication.handleRedirectTypeAsync,
  cancelSupplementAsync: dispatch.supplement.cancelSupplementAsync,
});

type Props = {
  bookingId: string;
} & ReturnType<typeof mapProps> &
  ReturnType<typeof mapDispatch>;

const BookingAddedSupplementList: FC<Props> = ({
  bookingId,
  bookingAddedSupplements,
  extras,
  options,
  bookingFolder,
  handleRedirectTypeAsync,
  cancelSupplementAsync,
}) => {
  const [globalContext] = useContext(GlobalContext) as any;
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [supplementToRemove, setSupplementToRemove] = useState(null);

  const getSupplementInfos = (supplement) => {
    let name = "";
    let image = "";

    if (supplement?.name == "AVOIR") {
      name = "Avoir"
    }
    if (supplement?.extraId) {
      if (name == "") {
        name = extras[supplement.extraId]?.name ?? "";
      }
      image = extras[supplement.extraId]?.photos[0] ?? "";
    }

    if (supplement?.optionId) {
      name = options[supplement.optionId]?.name ?? "";
      image = options[supplement.optionId]?.photos[0] ?? "";
    }

    return { name, image };
  };

  const handleRemoveSupplement = async () => {
    if (!supplementToRemove) return;

    setIsLoading(true);

    try {
      await cancelSupplementAsync({
        supplement: supplementToRemove,
        bookingId,
      });

      toast.success(globalContext.translations.successCancelSupplement);
    } catch (err) {
      console.log(err);
      toast.error(globalContext.translations.failedCancelSupplement);
    } finally {
      setIsModalOpen(false);
      setIsLoading(false);
    }
  };

  return (
    <>
      <List divided verticalAlign="middle">
        {bookingAddedSupplements?.[bookingId]?.list
          .sort((a, b) => a.id - b.id)
          .map((supplement, index) => {
            const { image, name } = getSupplementInfos(supplement);
            return (
              <List.Item key={index}>
                <Image avatar src={Utility.imageExists(image)} />
                <List.Content>
                  <List.Header>
                    <span className="mr-3">
                      {Utility.ucFirst(name)} x {supplement.totalQuantity}
                    </span>
                  </List.Header>
                </List.Content>
                <List.Content floated="right">
                  {// si option inclu ou dossier agence et supplement note principale
                  ((supplement?.isInclude || bookingFolder?.noteSecondaire) && !supplement?.isNote) ? (
                    Utility.ucFirst(globalContext.translations.includedValue)
                  ) : (
                    <>
                      {supplement.invoiceId !== 0 && (
                        <Icon name="file pdf outline" />
                      )}
                      <AmountProvider
                        amount={supplement.totalAmount}
                        currency={supplement.currency}
                      />
                      {!supplement.isMandatory &&
                        bookingFolder.state === "future" &&
                        supplement.totalAmount > 0 &&
                        supplement.closureId === 0 &&
                        (supplement.type !== 'extra' ||
                          (supplement.type === 'extra' &&
                            (supplement.PourImport === 'non' && supplement.hasInsuranceLink === false) ) ) &&
                        supplement.invoiceId === 0 && (
                          <Modal
                            closeIcon
                            open={isModalOpen}
                            trigger={
                              <Button
                                compact
                                basic
                                size="mini"
                                color="red"
                                icon="trash alternate outline"
                                onClick={() =>
                                  setSupplementToRemove(supplement)
                                }
                              />
                            }
                            onClose={() => setIsModalOpen(false)}
                            onOpen={() => setIsModalOpen(true)}
                          >
                            <Header
                              icon="trash"
                              content={
                                globalContext.translations
                                  .confirmCancelSupplement
                              }
                            />
                            <Modal.Content>
                              <div>
                                <h3 className="text-center">
                                  {
                                    getSupplementInfos(supplementToRemove)[
                                      "name"
                                    ]
                                  }
                                </h3>
                                <Image
                                  ui
                                  centered
                                  size="medium"
                                  src={Utility.imageExists(
                                    getSupplementInfos(supplementToRemove)[
                                      "image"
                                    ]
                                  )}
                                />
                              </div>
                              <p className="text-center mt-3">
                                {
                                  globalContext.translations
                                    .alertCancelSupplement
                                }
                              </p>
                            </Modal.Content>
                            <Modal.Actions>
                              <Button
                                color="red"
                                disabled={isLoading}
                                onClick={() => setIsModalOpen(false)}
                              >
                                <Icon name="remove" />{" "}
                                {globalContext.translations.back.ucfirst()}
                              </Button>
                              <Button
                                color="green"
                                loading={isLoading}
                                disabled={isLoading}
                                onClick={() =>
                                  handleRedirectTypeAsync(
                                    handleRemoveSupplement
                                  )
                                }
                              >
                                <Icon name="checkmark" />{" "}
                                {globalContext.translations.validate}
                              </Button>
                            </Modal.Actions>
                          </Modal>
                        )}
                    </>
                  )}
                </List.Content>
              </List.Item>
            );
          })}
      </List>
    </>
  );
};

export default connect(mapProps, mapDispatch)(BookingAddedSupplementList);